import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { STALE_TIME } from '@/api/staleTimes';
import {
  leaveTypeListSchema,
  type LeaveType,
  type CreateLeaveTypePayload,
  type UpdateLeaveTypePayload,
} from '../types/leaveType.types';

export const leaveTypeQueryKeys = {
  all: () => ['leave-types'] as const,
  list: () => [...leaveTypeQueryKeys.all(), 'list'] as const,
};

export const leaveTypesQueryOptions = () =>
  queryOptions({
    queryKey: leaveTypeQueryKeys.list(),
    queryFn: async (): Promise<LeaveType[]> => {
      const res = await apiClient.get(API.leaveType.list);
      return leaveTypeListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });

export async function createLeaveType(payload: CreateLeaveTypePayload): Promise<void> {
  await apiClient.post(API.leaveType.create, payload);
}

export async function updateLeaveType(id: number, payload: UpdateLeaveTypePayload): Promise<void> {
  await apiClient.patch(API.leaveType.update(id), payload);
}

export async function deleteLeaveType(id: number): Promise<void> {
  await apiClient.delete(API.leaveType.delete(id));
}
